export enum CategoryOpenSearch {
  ALL,
  HEALTH,
  LESSONS,
  EDUCATION,
  MIGRATION,
  EFFECTIVENESS,
  RISK,
  DEFAULT = '',
}

export enum CategoryOpenSearchClass {
  ALL = 'all',
  HEALTH = 'similar',
  LESSONS = 'lessons',
  EDUCATION = 'literature',
  MIGRATION = 'institutional',
  EFFECTIVENESS = '',
  RISK ='',
  DEFAULT = '',
}
